/**
* Image Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Image Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );

import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'image-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( this.selector() ).length ) {
        $( '.image-slider' ).each( function( index, element ) {
          const slider = new Splide( $( element )[0], {
            type: 'loop',
            perPage: 2,
            perMove: 1,
            drag: false,
            arrows: true,
            autoWidth: true,
            pagination: false,
            gap: '2rem',
            breakpoints: {
              768: {
                perPage: 1,
              },
              1024: {
                perPage: 3,
              },
            },
          } );

          slider.on( 'overflow', function( isOverflow ) {
            slider.options = {
              arrows: isOverflow,
              drag: isOverflow,
            };
          } );

          slider.mount();
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'image-slider', COMPONENT );
} )( app );
